
  module.exports =
  {

    _init: function ()
    {

      this.onAddCategory()

    },

    onAddCategory: function ()
    {

      $('#add-category').not('.js-ignore').click(function ()
      {

        var name = $('#name').val()

        var category_id = $('#isp_category_id').val()

        APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'i-s-p-category/edit?isp=' + name + '&category_id=' + category_id)

      }
      ).addClass('js-ignore')

    }

  }